export const CalendarIcon = () => {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_1444_19993" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 1.47913C1.67893 1.47913 0 3.15806 0 5.22913V12.3882C0 14.4593 1.67893 16.1382 3.75 16.1382H11.25C13.3211 16.1382 15 14.4593 15 12.3882V5.22912C15 3.15806 13.3211 1.47913 11.25 1.47913H3.75ZM5 5.2789C3.89543 5.2789 3 6.17433 3 7.2789C3 8.38347 3.89543 9.2789 5 9.2789H10C11.1046 9.2789 12 8.38347 12 7.2789C12 6.17433 11.1046 5.2789 10 5.2789H5Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 1.47913C1.67893 1.47913 0 3.15806 0 5.22913V12.3882C0 14.4593 1.67893 16.1382 3.75 16.1382H11.25C13.3211 16.1382 15 14.4593 15 12.3882V5.22912C15 3.15806 13.3211 1.47913 11.25 1.47913H3.75ZM5 5.2789C3.89543 5.2789 3 6.17433 3 7.2789C3 8.38347 3.89543 9.2789 5 9.2789H10C11.1046 9.2789 12 8.38347 12 7.2789C12 6.17433 11.1046 5.2789 10 5.2789H5Z"
        fill="#557F78"
      />
      <path
        d="M0.340909 5.22913C0.340909 3.34634 1.86721 1.82004 3.75 1.82004V1.13822C1.49065 1.13822 -0.340909 2.96978 -0.340909 5.22913H0.340909ZM0.340909 12.3882V5.22913H-0.340909V12.3882H0.340909ZM3.75 15.7973C1.86721 15.7973 0.340909 14.271 0.340909 12.3882H-0.340909C-0.340909 14.6476 1.49065 16.4791 3.75 16.4791V15.7973ZM11.25 15.7973H3.75V16.4791H11.25V15.7973ZM14.6591 12.3882C14.6591 14.271 13.1328 15.7973 11.25 15.7973V16.4791C13.5093 16.4791 15.3409 14.6476 15.3409 12.3882H14.6591ZM14.6591 5.22912V12.3882H15.3409V5.22912H14.6591ZM11.25 1.82004C13.1328 1.82004 14.6591 3.34634 14.6591 5.22912H15.3409C15.3409 2.96978 13.5093 1.13822 11.25 1.13822V1.82004ZM3.75 1.82004H11.25V1.13822H3.75V1.82004ZM3.34091 7.2789C3.34091 6.36261 4.08371 5.61981 5 5.61981V4.93799C3.70715 4.93799 2.65909 5.98605 2.65909 7.2789H3.34091ZM5 8.93799C4.08371 8.93799 3.34091 8.19519 3.34091 7.2789H2.65909C2.65909 8.57175 3.70715 9.61981 5 9.61981V8.93799ZM10 8.93799H5V9.61981H10V8.93799ZM11.6591 7.2789C11.6591 8.19519 10.9163 8.93799 10 8.93799V9.61981C11.2928 9.61981 12.3409 8.57175 12.3409 7.2789H11.6591ZM10 5.61981C10.9163 5.61981 11.6591 6.36261 11.6591 7.2789H12.3409C12.3409 5.98605 11.2928 4.93799 10 4.93799V5.61981ZM5 5.61981H10V4.93799H5V5.61981Z"
        fill="#557F78"
        mask="url(#path-1-inside-1_1444_19993)"
      />
      <path
        d="M3.06812 0.797241L3.06812 4.20633"
        stroke="#557F78"
        strokeWidth="1.36364"
        stroke-linecap="round"
      />
      <path
        d="M11.9316 0.797241L11.9316 4.20633"
        stroke="#557F78"
        strokeWidth="1.36364"
        stroke-linecap="round"
      />
    </svg>
  );
};
